import styled from "styled-components";
import { Form, InputGroup } from "react-bootstrap";
import FormRange from "react-bootstrap/esm/FormRange";
export const FormErrorMessage = styled(Form.Control.Feedback)`
    font-weight: bold;
    margin-top: 0;
    font-size: .9em;
`
export const FormLabel = styled(Form.Label)`
    font-weight: 500;
    font-size: 1em;
`
export const InputGroupControl = styled(InputGroup.Text)`
    cursor: pointer;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        background: var(--bs-body-focus-bg);
    }
    &.input-light{
        --bs-body-bg: #e1e1e1;
        --bs-border-color: #e1e1e1;
        --bs-body-color: #333;
        --bs-body-focus-color: #444;
        --bs-body-focus-bg: #fff;
        --bs-tertiary-bg: #f1f1f1;
        &:disabled{
            background-color: #c5c5c5;
            border-color: #c5c5c5;
            color: #5d5d5d;
        }
    }
`
export const FormSelectContainer = styled(Form.Select)`
    padding: .7em .7em;
    font-size: 1.1em;
    line-height: normal;
    &:focus{
        color: var(--bs-body-focus-color);
        background: var(--bs-body-focus-bg);
        border-color: var(--bs-border-hover-color);
        box-shadow: 0 0 0 .1rem var(--bs-box-shadow);
    }
    &:hover{
        color: var(--bs-body-focus-color);
        border-color: var(--bs-border-hover-color);
    }
    &:disabled {
        background-color: var(--bs-border-color);
        opacity: 1;
        &:hover{
            border-color: var(--bs-border-color);
        }
    }
    &.input-light{
        --bs-body-bg: #e1e1e1;
        --bs-border-color: #e1e1e1;
        --bs-body-color: #333;
        --bs-body-focus-color: #444;
        --bs-body-focus-bg: #fff;
        &:disabled{
            background-color: #c5c5c5;
            border-color: #c5c5c5;
            color: #5d5d5d;
        }
    }
`
export const FormControl = styled(Form.Control)`
    padding: .7em .7em;
    font-size: 1.1em;
    line-height: normal;
    &.ltr{
        direction: ltr !important;
    }
    &:focus{
        color: var(--bs-body-focus-color);
        background: var(--bs-body-focus-bg);
        border-color: var(--bs-border-hover-color);
        box-shadow: 0 0 0 .1rem var(--bs-box-shadow);
    }
    &:hover{
        color: var(--bs-body-focus-color);
        border-color: var(--bs-border-hover-color);
    }
    &:disabled {
        background-color: var(--bs-border-color);
        opacity: 1;
        &:hover{
            border-color: var(--bs-border-color);
        }
    }
    &.input-light{
        --bs-body-bg: #e1e1e1;
        --bs-border-color: #e1e1e1;
        --bs-body-color: #333;
        --bs-body-focus-color: #444;
        --bs-body-focus-bg: #fff;
        &:disabled{
            background-color: #c5c5c5;
            border-color: #c5c5c5;
            color: #5d5d5d;
        }
    }
`
export const FormInputError = styled.div`
    color: var(--bs-form-invalid-border-color);
    font-size: .7em;
`
export const InputContainer = styled.div`
    &.ltr{
        direction: ltr !important;
    }
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: .2em;
`
export const FormCodeInputContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin: .5em 0;
    direction: ltr !important;
    & .form-control{
        height: 50px;
        width: 50px;
        text-align: center;
        background: #6d6d6d;
        border-color: #6d6d6d;
        color: #111;
        &.is-invalid{
            background-image: none;
            padding-right: .75rem;
        }
    }
    &.input-light{
        & .form-control{
            background: #e1e1e1;
            border-color: #e1e1e1;
            color: #333;
            &:disabled{
                background-color: #c5c5c5;
                border-color: #c5c5c5;
                color: #5d5d5d;
            }
        }
        
    }

`
export const Timer = styled.div`
    margin-top: 1em;
    text-align: center;
    font-weight: bold;
`
export const Required = styled.span`
    color: #ff0000;
`